import React from 'react';
import DetailsComponent from '../components/teacherComponents/DetailsComponent';

const TeacherDetails = () => {

    return (
    <>
    
       <DetailsComponent/>
        
        </>
    );
};

export default TeacherDetails;
